/** Page 01 — North Star: where we must rank among Chinese brands. */
export interface NorthStarItem {
  rank: 'Top 1' | 'Top 3' | 'Top 5';
  name: string;
  note: string;
}

export const NORTH_STAR_TITLE = 'North Star — where we must rank among Chinese brands';

export const NORTH_STAR: readonly NorthStarItem[] = [
  { rank: 'Top 5', name: 'Market share', note: 'Of the Chinese market' },
  { rank: 'Top 5', name: 'Brand equity', note: 'Among Chinese brands' },
  { rank: 'Top 3', name: 'Specs', note: 'Best-equipped in class' },
  { rank: 'Top 3', name: 'Pricing', note: 'Sharpest vehicle pricing' },
  { rank: 'Top 3', name: 'Financing', note: 'Easiest path to yes' },
  { rank: 'Top 1', name: 'Service', note: 'Quality + pricing leader' },
  { rank: 'Top 1', name: 'Spare parts', note: 'Availability + pricing leader' },
];
